import GradeEdit from "@/controllers/grade/grade-edit.js";
import CONFIG from "@/assets/js/config.custom.js";
import Select2Multiple from 'v-select2-multiple-component';
import { required } from 'vuelidate/lib/validators';

export default {
  extends: GradeEdit,
  components: {
    Select2Multiple
  },

  data() {
    return {
      gradeData: {
        division: null,
        is_final_year: false
      }
    }
  },

  computed: {
    divisionOptions() {
      return Object.entries(CONFIG.DIVISION).map(([id, text]) => ({
        id: parseInt(id),
        text: text
      }));
    }
  },

  validations: {
    gradeData: {
      grade_name: GradeEdit.validations.gradeData.grade_name,
      division: {
        required,
        validDivision: (value) => {
          if (!value) return true;
          const divisionValue = parseInt(value);
          return Object.keys(CONFIG.DIVISION)
            .map(id => parseInt(id))
            .includes(divisionValue);
        }
      }
    }
  },

  methods: {
    ...GradeEdit.methods
  }
};
